import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import {
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
} from '../activity-builder.constants';
import { PRESENT_PROGRESS_BAR_Z_INDEX } from './activity-builder-present.constants';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';

type ActivityPresentBannerProps = {
  $isDrawerDetailsActive?: boolean;
};
export const ActivityPresentBanner = styled.div<ActivityPresentBannerProps>`
  ${flexCentreAlignCss}

  position: fixed;
  top: ${rem(spacing8)};
  left: 0;
  right: ${rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)};
  background-color: ${grey1};
  z-index: ${PRESENT_PROGRESS_BAR_Z_INDEX - 1};

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    right: ${({ $isDrawerDetailsActive }) =>
      $isDrawerDetailsActive
        ? rem(ACTIVITY_BUILDER_SETTINGS_WIDTH + 340)
        : rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)};
  }
`;
